import Swal from "sweetalert2";

export function token_expired(response, router) {
  if (response.status === 401 || response.request.status === 401) {
    Swal.fire({
      title: "Error",
      text: "Your session has expired.",
      icon: "error",
      confirmButtonText: "Close",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        router.push("/").catch(err => {
          console.error('Navigation error:', err);
        });
      }
    });
  }
}
